import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { preparaSessioneAssociato, avviaRinnovoSessioneAssociato } from './services/rinnovoSessioneAssociato';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// «Rinnovo a 90»: un token dell'associato scaduto ma rinnovabile si rinnova PRIMA del primo
// disegno (al più 8 s), poi il rinnovo continua in sottofondo ogni 12 ore.
preparaSessioneAssociato().then(() => {
  root.render(
    // StrictMode temporaneamente disabilitato per compatibilità con Leaflet e React 19
    // React.StrictMode monta i componenti due volte causando "Map container is already initialized"
    <App />
  );
  avviaRinnovoSessioneAssociato();
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
